var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 1200,
        scrollable: "",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onVisibleChange },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", { staticClass: "header-container" }, [
          _c("div", [
            _c("p", [
              _c("span", [
                _vm._v(_vm._s(_vm.isEditMode ? "产品编辑" : "产品新增")),
              ]),
              _vm.isEditMode
                ? _c(
                    "span",
                    { staticStyle: { "margin-left": "20px", color: "blue" } },
                    [_vm._v(_vm._s(_vm.productCode))]
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "copy-section" },
            [
              _c("span", [_c("b", [_vm._v("复制商品信息(全局):")])]),
              _c("ProductSelector", {
                ref: "productIdSelector1",
                staticStyle: { "margin-left": "20px" },
                attrs: {
                  productUuid: _vm.productId1,
                  productList: _vm.productList,
                },
                on: { onProductChange: _vm.onProductInfo1Change },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
      _c(
        "Tabs",
        {
          attrs: { animated: false, "capture-focus": true },
          model: {
            value: _vm.editType,
            callback: function ($$v) {
              _vm.editType = $$v
            },
            expression: "editType",
          },
        },
        [
          _c(
            "TabPane",
            { attrs: { label: "基础信息", name: "productInfo" } },
            [
              _c("ProductPopupEdit", {
                ref: "productPopupEdit",
                attrs: {
                  formEditMode: _vm.formEditMode,
                  popupEditResource: _vm.popupEditResource,
                  productList: _vm.productList,
                },
                on: { "on-popup-submit-finish": _vm.popupSubmitFinish },
              }),
            ],
            1
          ),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "特别通告", name: "productInfo2" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector2",
                        attrs: {
                          productUuid: _vm.productId2,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo2Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfopOtherSpec"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfopOtherSpec,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfopOtherSpec",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfopOtherSpec",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "品种介绍", name: "productInfo3" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector3",
                        attrs: {
                          productUuid: _vm.productId3,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo3Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInffeatures"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInffeatures,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInffeatures",
                                  $$v
                                )
                              },
                              expression: "productForm.productDesInffeatures",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Row", { attrs: { justify: "center" } }),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "栽培技术", name: "productInfo4" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector4",
                        attrs: {
                          productUuid: _vm.productId4,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo4Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoCultivation"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoCultivation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoCultivation",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoCultivation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "常见问题", name: "productInfo5" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector5",
                        attrs: {
                          productUuid: _vm.productId5,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo5Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoCommonProblem"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm.productDesInfoCommonProblem,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoCommonProblem",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoCommonProblem",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "关于售后", name: "productInfo6" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector6",
                        attrs: {
                          productUuid: _vm.productId6,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo6Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoafterService"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoafterService,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoafterService",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoafterService",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "优惠政策", name: "productInfo7" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector7",
                        attrs: {
                          productUuid: _vm.productId7,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo7Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfodiscountPolicy"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm.productDesInfodiscountPolicy,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfodiscountPolicy",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfodiscountPolicy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "PDF目录", name: "productInfo8" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector8",
                        attrs: {
                          productUuid: _vm.productId8,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo8Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("pdf-upload", {
                            attrs: {
                              productUuid: _vm.productUuid,
                              uploadData: _vm.getUploadData(
                                "productDesInfoPdfLinkList"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoPdfLinkList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoPdfLinkList",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoPdfLinkList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "病虫防治", name: "productInfo9" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector9",
                        attrs: {
                          productUuid: _vm.productId9,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo9Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoDiseasePestControl"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm
                                  .productDesInfoDiseasePestControl,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoDiseasePestControl",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                productForm.productDesInfoDiseasePestControl\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEditMode
            ? _c(
                "TabPane",
                { attrs: { label: "采后处理", name: "productInfo10" } },
                [
                  _c(
                    "div",
                    { staticClass: "copy-section" },
                    [
                      _c("span", [_c("b", [_vm._v("复制商品信息(局部):")])]),
                      _c("ProductSelector", {
                        ref: "productIdSelector10",
                        attrs: {
                          productUuid: _vm.productId10,
                          productList: _vm.productList,
                        },
                        on: { onProductChange: _vm.onProductInfo10Change },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoPostHarvestProcessing"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm
                                  .productDesInfoPostHarvestProcessing,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoPostHarvestProcessing",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                productForm.productDesInfoPostHarvestProcessing\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          this.$checkAccessArray(["B", "C"])
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.basicInformationubmit },
                },
                [_vm._v("保存基础信息")]
              )
            : _vm._e(),
          this.$checkAccessArray(["B", "C"]) && _vm.isEditMode
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveProductDescriptiveInformation },
                },
                [_vm._v("保存说明信息")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }